/* melee-v2-hero.js — migrated out of sections/melee-v2-hero.liquid's {% javascript %} block
   to avoid the local theme-dev compiled_assets/scripts.js truncation bug. */
(function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function initHero(root) {
      if (!root || root.dataset.mv2HeroReady === '1') return;
      root.dataset.mv2HeroReady = '1';

      var CONFIG = {
        logoOutStart: 0.03, // logo is fully shown until here, then fades OUT
        logoOutEnd: 0.22, // logo gone by here
        barStart: 0.7, // action bar begins revealing well before the end
        barEnd: 0.84, // fully in with scroll room to spare, so it's noticed
        endPad: 0.04, // seconds shy of the very end (avoids 'ended' flicker)
        smooth: 0.14, // scroll easing (lower = smoother / looser)
        navOffsetDesktop: 125, // fixed navbar height, once it's actually stuck (>760px)
        navOffsetMobile: 81, // fixed navbar height, once it's actually stuck (<=760px)
        navStickyScrollY: 250, // theme.js only adds .site-header--stuck past this scrollY
      };

      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      var video = root.querySelector('[data-mv2-hero-video]');
      var logo = root.querySelector('[data-mv2-hero-logo]');
      var reveal = root.querySelector('[data-mv2-hero-reveal]');
      var cue = root.querySelector('[data-mv2-hero-cue]');
      var bar = root.querySelector('[data-mv2-hero-bar]');

      // pick the source AND matching poster for this viewport before the
      // scrub script uses them — a lighter cut + portrait poster on phones
      if (video) {
        var mobile = matchMedia('(max-width: 760px)').matches;
        var poster = video.getAttribute(mobile ? 'data-poster-mobile' : 'data-poster-desktop');
        var src = video.getAttribute(mobile ? 'data-src-mobile' : 'data-src-desktop');
        if (poster) video.poster = poster;
        if (src) video.src = src;
      }

      var dur = 0;
      var sp = 0,
        targetP = 0,
        rafId = null;

      var clamp = function (v, a, b) {
        a = a === undefined ? 0 : a;
        b = b === undefined ? 1 : b;
        return Math.max(a, Math.min(b, v));
      };
      var map = function (v, a, b) {
        return clamp((v - a) / (b - a));
      };
      var smoothstep = function (t) {
        return t * t * (3 - 2 * t);
      };

      function applyScrub() {
        if (video && dur) {
          var t = clamp(sp) * (dur - CONFIG.endPad);
          if (Math.abs(video.currentTime - t) > 0.015 && video.readyState >= 1) {
            try {
              video.currentTime = t;
            } catch (e) {}
          }
        }

        if (logo) {
          var lo = 1 - smoothstep(map(sp, CONFIG.logoOutStart, CONFIG.logoOutEnd));
          logo.style.opacity = String(lo);
          logo.style.setProperty('--logo-scale', (1 + 0.05 * (1 - lo)).toFixed(3));
          if (reveal) reveal.style.opacity = String(lo * 0.6);
        }

        if (bar) {
          var bl = smoothstep(map(sp, CONFIG.barStart, CONFIG.barEnd));
          bar.style.opacity = String(bl);
          bar.style.transform = 'translateY(' + (14 * (1 - bl)).toFixed(1) + 'px)';
          bar.style.pointerEvents = bl > 0.5 ? 'auto' : 'none';
        }

        if (cue) cue.style.opacity = sp > 0.02 ? '0' : '1';
      }

      function getTopOffset() {
        // The announcement bar + navbar sit in normal document flow above
        // the hero, so the space they take up is already baked into
        // root.getBoundingClientRect().top on its own -- no manual offset
        // needed for that part, or the reveal starts too late.
        //
        // What rect.top can't see is the navbar going position: fixed.
        // theme.js only adds .site-header--stuck (and with it, fixed
        // positioning) once window.scrollY passes navStickyScrollY -- up to
        // that point the navbar has simply scrolled off with everything
        // else above the hero and covers nothing. Only past that point does
        // it re-appear pinned on top of the video, eating into the visible
        // area. So the offset has to switch on at that same scrollY, not
        // from the very start of the scrub.
        if (window.scrollY <= CONFIG.navStickyScrollY) return 0;
        var mobile = matchMedia('(max-width: 760px)').matches;
        return mobile ? CONFIG.navOffsetMobile : CONFIG.navOffsetDesktop;
      }

      function computeTarget() {
        var topOffset = getTopOffset();
        var rect = root.getBoundingClientRect();
        var scrollable = rect.height - window.innerHeight + topOffset;
        targetP = scrollable > 0 ? clamp((topOffset - rect.top) / scrollable) : 0;
      }

      function tick() {
        var diff = targetP - sp;
        if (Math.abs(diff) < 0.0004) {
          sp = targetP;
          applyScrub();
          rafId = null;
          return;
        }
        sp += diff * CONFIG.smooth;
        applyScrub();
        rafId = requestAnimationFrame(tick);
      }
      function requestTick() {
        if (rafId == null) rafId = requestAnimationFrame(tick);
      }

      function onScroll() {
        computeTarget();
        if (reduce) {
          sp = targetP;
          applyScrub();
          return;
        }
        requestTick();
      }
      function onResize() {
        computeTarget();
        applyScrub();
      }

      function start() {
        dur = (video && video.duration) || 0;
        if (video) video.pause();
        computeTarget();
        sp = targetP;
        applyScrub();
        if (!reduce) requestTick();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      if (video) {
        if (video.readyState >= 1 && video.duration) start();
        else video.addEventListener('loadedmetadata', start, { once: true });
        video.load(); // nudge the browser to buffer so seeks are ready
      } else {
        start();
      }
    }

    function initAll() {
      document.querySelectorAll('[data-mv2-hero]').forEach(initHero);
    }

    ready(initAll);
    document.addEventListener('shopify:section:load', function (evt) {
      var root = evt.target && evt.target.querySelector ? evt.target.querySelector('[data-mv2-hero]') : null;
      if (root) {
        root.dataset.mv2HeroReady = '0';
        initHero(root);
      }
    });
  })();
